export const filterOptions = [
  { key: 'usr_uuid', label: 'DYNAMIC_FILTER.USER_UUID_KEY' },
  { key: 'username', label: 'DYNAMIC_FILTER.AD_USERNAME_KEY' },
  { key: 'partner_name', label: 'DYNAMIC_FILTER.PARTNER_NAME_KEY' },
  { key: 'partner_uuid', label: 'DYNAMIC_FILTER.PARTNER_UUID_KEY' },
  { key: 'first_name', label: 'DYNAMIC_FILTER.FIRST_NAME_KEY' },
  { key: 'last_name', label: 'DYNAMIC_FILTER.LAST_NAME_KEY' },
  { key: 'environment_name', label: 'DYNAMIC_FILTER.ENVIRONMENT_NAME_KEY' },
  { key: 'environment_uuid', label: 'DYNAMIC_FILTER.ENVIRONMENT_UUID_KEY' },
  { key: 'email', label: 'DYNAMIC_FILTER.EMAIL_KEY' },
  { key: 'company_name', label: 'DYNAMIC_FILTER.COMPANY_NAME_KEY' },
  { key: 'company_uuid', label: 'DYNAMIC_FILTER.COMPANY_UUID_KEY' },
  { key: 'client_name', label: 'DYNAMIC_FILTER.CLIENT_NAME_KEY' },
  { key: 'client_uuid', label: 'DYNAMIC_FILTER.CLIENT_UUID_KEY' },
  {
    key: 'active',
    label: 'DYNAMIC_FILTER.STATUS_KEY',
    isSelect: true,
    selectType: [
      { key: 'True', label: 'DYNAMIC_FILTER.ACTIVE_KEY' },
      { key: 'False', label: 'DYNAMIC_FILTER.INACTIVE_KEY' },
    ],
  },
  { key: 'request_uuid', label: 'REQUEST_ID_KEY' },
  { key: 'recovery_uuid', label: 'RECOVERY_ID_KEY' },
];
